import React, { Fragment, useEffect, useState } from 'react';
import { Col, Form, Row, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import TextInput from "../../components/InputFields/TextInput";
import { useFormik } from "formik";
import { formikAddClinic, organizationTypeOption } from "./Constant";
import { failed, success } from "../../utils/Tostify";
import { decryptData } from "../../utils/helper";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { createClinic, createOrg } from "../../api/orgnizations";
import Loader from "../../components/Loader/Loader";
import { useGetStates } from "../../hooks/useGetStates";
import "./Organization.css";

function AddClinic({ setShowModal, orgValues, fromListing, refetch }) {
    let token = useSelector(state => state.userReducer.token);
    const [isLoading, setIsLoading] = useState(false);
    const [Countryvalue, setCountryValue] = useState();
    const [stateValue, setStateValue] = useState();
    const dispatch = useDispatch();
    const location = useLocation();
    const orgData = location?.state?.orgData;
    const { states, countryOptions } = useGetStates(Countryvalue);
    const formik = useFormik({
        ...formikAddClinic,
        onSubmit: async (values) => {
            let res;
            try {
                setIsLoading(true);
                if(!localStorage.getItem("orgId")){
                    res = await createOrg({ values: orgValues, dispatch, token });
                    const org = decryptData(res?.data);
                    if (res?.status === "SUCCESS") {
                        values.orgId = org?._id;
                        res = await createClinic({ values, dispatch, token });
                        const responseData = decryptData(res?.data);
                        if (res?.status === "SUCCESS") {
                            setIsLoading(false);
                            setShowModal(false);
                            refetch(org?._id);
                            formik.setFieldValue("orgId", org._id);
                            localStorage.setItem("orgId", org._id);
                            success(res?.message);
                            formik.resetForm();
                        }
                    }else{
                        setIsLoading(false);
                        failed(res?.message);
                    }
                    localStorage.removeItem("addHospital");
                }else{
                    values.orgId = localStorage.getItem("orgId");
                    res = await createClinic({ values, dispatch, token });
                    const responseData = decryptData(res?.data);
                    if (res?.status === "SUCCESS") {
                        setIsLoading(false);
                        setShowModal(false);
                        refetch(localStorage.getItem("orgId"));
                        success(res?.message);
                        formik.resetForm();
                        // navigate("/super-admin/clinicslist");
                    }
                }

            } catch (error) {
                setIsLoading(false);
                failed(res?.message);
            }
        }
    });

    const CountrychangeHandler = e => {
        setCountryValue(e.target.value);
        formik.setFieldValue("country", countryOptions.find((obj) => obj.value === e.target.value).label);
    };

    const stateHandler = (e) => {
        setStateValue(e.target.value);
        formik.setFieldValue('state', e.target.value);
    };

    useEffect(() => {
        if(fromListing){
            formik.setFieldValue("orgId", orgData?._id);
            localStorage.setItem("orgId", orgData?._id);
        }
    }, []);
    useEffect(() => {
        if (setShowModal) {
          const modalBody = document.querySelector('.assign_modal_body');
          if (modalBody) {
            modalBody.scrollTop = 0;
          }
        }
      }, [setShowModal]);

    return (
        <Fragment>
            <Modal isOpen={setShowModal} toggle={setShowModal} size="xl" className="clinic_modal">
            <ModalHeader toggle={setShowModal} className="assign_blk mb-3 p-0">Add Hospital</ModalHeader>
            <Form onSubmit={formik.handleSubmit}>
                <ModalBody className="assign_modal_body">
                    {isLoading ? <Loader /> : null}
                    <div className="organization_form_block organization_blk organization_modal modal_change_color p-4">
                        <div className="d-flex gap-4">
                            <div className="forms_block">
                                    <div className="first_block">
                                        <Row>
                                            <Col lg={6} className="location_block">
                                                <TextInput
                                                    keyField={"clinicName"}
                                                    formik={formik}
                                                    label="Hospital Name"
                                                    type="text"
                                                    value={formik.values.clinicName}
                                                    onChange={(e) =>formik.setFieldValue("clinicName", e.target.value)}
                                                    autoFocus={true}
                                                />
                                            </Col>
                                            <Col lg={6} className="location_block">
                                                <TextInput
                                                    keyField={"email"}
                                                    formik={formik}
                                                    label="Hospital Email"
                                                    type="text"
                                                    value={formik.values.email}
                                                    onChange={(e) => formik.setFieldValue("email", e.target.value)}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg={6} className="location_block">
                                                <TextInput
                                                    keyField={"phone"}
                                                    formik={formik}
                                                    label="Hospital Phone"
                                                    required={false}
                                                    type="phone"
                                                    value={formik.values.phone}
                                                    onChange={(e) => formik.setFieldValue("phone", e)}
                                                />
                                            </Col>
                                            <Col lg={6} className="location_block">
                                                <TextInput
                                                    keyField={"type"}
                                                    formik={formik}
                                                    label="Hospital Type"
                                                    type="select"
                                                    options={organizationTypeOption}
                                                    value={formik.values.type}
                                                    onChange={(e) =>formik.setFieldValue("type", e.target.value)}
                                                />
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="first_block">
                                        <Row>
                                            <Col lg={6} className="location_block">
                                                <h6 className="block_name">Primary Contact Person</h6>
                                                <TextInput
                                                    keyField={"contactName"}
                                                    formik={formik}
                                                    label="Name"
                                                    placeholder={"Name"}
                                                    type="text"
                                                    value={formik.values.contactName}
                                                    onChange={(e) =>formik.setFieldValue("contactName", e.target.value)}
                                                />
                                            </Col>
                                            <Col lg={6} className="location_block">
                                                <h6 className="block_name">
                                                    Secondary Contact Person (Optional)
                                                </h6>
                                                <TextInput
                                                    keyField={"secondaryContactName"}
                                                    formik={formik}
                                                    label="Name"
                                                    type="text"
                                                    required={false}
                                                    placeholder="Name"
                                                    value={formik.values?.secondaryContactName}
                                                    onChange={(e) =>formik.setFieldValue("secondaryContactName", e.target.value)}
                                                />
                                            </Col>
                                            <Col lg={6} className="location_block">
                                                <TextInput
                                                    keyField={"contactEmail"}
                                                    formik={formik}
                                                    label="Email"
                                                    type="email"
                                                    placeholder="Email"
                                                    value={formik.values.contactEmail}
                                                    onChange={(e) =>formik.setFieldValue("contactEmail", e.target.value)}
                                                />
                                            </Col>
                                            <Col lg={6} className="location_block">
                                            <TextInput
                                                keyField={"secondarycontactEmail"}
                                                formik={formik}
                                                label="Email"
                                                type="email"
                                                placeholder="Email"
                                                required={false}
                                                value={formik.values.secondarycontactEmail}
                                                onChange={(e) =>formik.setFieldValue("secondarycontactEmail", e.target.value)}
                                            />
                                            </Col>
                                            <Col lg={6} className="location_block">
                                                <TextInput
                                                    keyField={"contactPhone"}
                                                    formik={formik}
                                                    label="Phone"
                                                    type="phone"
                                                    placeholder="Phone"
                                                    required={false}
                                                    value={formik.values.contactPhone}
                                                    onChange={(e) => formik.setFieldValue("contactPhone", e)}
                                                />
                                            </Col>
                                            <Col lg={6} className="location_block">
                                            <TextInput
                                                keyField={"secondaryContactPhone"}
                                                formik={formik}
                                                label="Phone"
                                                type="phone"
                                                placeholder="Phone"
                                                required={false}
                                                value={formik.values.secondaryContactPhone}
                                                onChange={(e) => formik.setFieldValue("secondaryContactPhone", e)}
                                            />
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="first_block second_block">
                                        <h6 className="block_name text-center">Address Information</h6>
                                        <Row>
                                            <Col lg={12} className="location_block">
                                                <TextInput
                                                    keyField={"address"}
                                                    formik={formik}
                                                    label="Street"
                                                    type="text"
                                                    value={formik.values.address}
                                                    onChange={(e) =>formik.setFieldValue("address", e.target.value)}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg={6} className="location_block">
                                                <TextInput
                                                    keyField={"country"}
                                                    formik={formik}
                                                    options={countryOptions}
                                                    label="Country"
                                                    type="select"
                                                    value={Countryvalue}
                                                    onChange={CountrychangeHandler}
                                                />
                                            </Col>
                                            <Col lg={6} className="location_block">
                                                <TextInput
                                                    keyField={"state"}
                                                    formik={formik}
                                                    label="State"
                                                    options={states.map((obj) => {
                                                        return {
                                                            label: obj.name,
                                                            value: obj.name
                                                        };
                                                    })}
                                                    type="select"
                                                    value={stateValue}
                                                    onChange={stateHandler}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg={6} className="location_block">
                                                <TextInput
                                                    keyField={"city"}
                                                    formik={formik}
                                                    label="City"
                                                    type="text"
                                                    value={formik.values.city}
                                                    onChange={(e) =>
                                                        formik.setFieldValue("city", e.target.value)
                                                    }
                                                />
                                            </Col>
                                            <Col lg={6} className="location_block">
                                                <TextInput
                                                    keyField={"postalCode"}
                                                    formik={formik}
                                                    label="Zip Code"
                                                    type="text"
                                                    value={formik.values.postalCode}
                                                    onChange={(e) =>
                                                        formik.setFieldValue("postalCode", e.target.value)
                                                    }
                                                />
                                            </Col>
                                        </Row>
                                    </div>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter className="p-0 mt-3">
                    <div className="d-flex justify-content-between">
                        <button className="save_btn" onClick={setShowModal}>Close</button>
                        <button className="save_btn" type="submit">Save</button>
                    </div>
                </ModalFooter>
            </Form>
            </Modal>
        </Fragment>
    );
}

export default AddClinic;
